import React, { useState, useEffect } from 'react'
import {
  Create,
  SimpleForm,
  useRedirect,
  SelectInput,
  NumberInput,
  ReferenceInput,
  TextInput,
  useInput,
  required,
  useNotify,
  BooleanInput,
  Button,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import AceEditor from 'react-ace'
import 'ace-builds/src-noconflict/mode-json'
import 'ace-builds/src-noconflict/theme-textmate'
import productOrigin from './../list-product-origin'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    flexGrow: 1,
  },
  input: {
    marginBottom: '-20px',
  },
}))

const ValidatorInput = (props) => {
  const [validatorValue, setValidatorValue] = useState('')
  const [isChanged, setIsChanged] = useState(false)
  const validator = useInput(props)

  useEffect(() => {
    setValidatorValue(JSON.stringify(validator.input.value, null, '\t'))
    setIsChanged(false)
  }, [validator.input.value])

  function onChange(newValue) {
    setValidatorValue(newValue)
    setIsChanged(true)
  }

  function saveToForm() {
    const parsed = JSON.parse(validatorValue)
    validator.input.onChange(parsed)
  }

  return (
    <div>
      <AceEditor
        name="validator"
        style={{ height: '200px', width: '100%' }}
        mode="json"
        theme="textmate"
        onChange={onChange}
        value={validatorValue}
      />
      {isChanged && (
        <Button variant="contained" size="small" color="primary" onClick={saveToForm}>
          <>Commit Changes</>
        </Button>
      )}
    </div>
  )
}

const DataInput = (props) => {
  const [dataValue, setDataValue] = useState('')
  const [isChanged, setIsChanged] = useState(false)
  const data = useInput(props)

  useEffect(() => {
    setDataValue(JSON.stringify(data.input.value, null, '\t'))
    setIsChanged(false)
  }, [data.input.value])

  function onChange(newValue) {
    setDataValue(newValue)
    setIsChanged(true)
  }

  function saveToForm() {
    const parsed = JSON.parse(dataValue)
    data.input.onChange(parsed)
  }

  return (
    <div>
      <AceEditor
        name="data"
        style={{ height: '200px', width: '100%' }}
        mode="json"
        theme="textmate"
        onChange={onChange}
        value={dataValue}
      />
      {isChanged && (
        <Button variant="contained" size="small" color="primary" onClick={saveToForm}>
          <>Commit Changes</>
        </Button>
      )}
    </div>
  )
}

export default function PageCreate(props) {
  const classes = useStyles()
  const notify = useNotify()
  const redirect = useRedirect()

  const onSuccess = () => {
    notify('ra.notification.created', 'info', { smart_count: 1 })
    redirect('/products')
  }

  return (
    <Create {...props} onSuccess={onSuccess}>
      <SimpleForm>
        <div className={classes.root}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <TextInput fullWidth className={classes.input} source="product_code" label="Code" />
            </Grid>
            <Grid item xs={6}>
              <TextInput fullWidth className={classes.input} source="name" label="Name" />
            </Grid>
            <Grid item xs={6}>
              <SelectInput
                source="country"
                fullWidth
                validate={[required()]}
                className={classes.input}
                choices={productOrigin}
              />
            </Grid>
            <Grid item xs={6}>
              <ReferenceInput
                fullWidth
                className={classes.input}
                label="Organization"
                source="organization_id"
                reference="organizations"
                validate={[required()]}
              >
                <SelectInput source="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={12}>
              <TextInput
                fullWidth
                className={classes.input}
                multiline
                source="description"
                label="Description"
              />
            </Grid>
            <Grid item xs={6}>
              <p>Validator</p>
              <ValidatorInput source="validator" className={classes.input} />
            </Grid>
            <Grid item xs={6}>
              <p>Data</p>
              <DataInput source="data" />
            </Grid>
            <Grid item xs={6}>
              <NumberInput fullWidth source="denomination" />
            </Grid>
            <Grid item xs={6}>
              <NumberInput fullWidth className={classes.input} source="min_denomination" />
            </Grid>
            <Grid item xs={6}>
              <TextInput
                fullWidth
                className={classes.input}
                source="sub_id"
                validate={[required()]}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectInput
                source="rpg_method"
                fullWidth
                validate={[required()]}
                className={classes.input}
                optionText="id"
                choices={[
                  { id: 'ABSOLUTE', name: 'Absolute' },
                  { id: 'PERCENT', name: 'Percent' },
                ]}
              />
            </Grid>
            <Grid item xs={6}>
              <NumberInput
                source="rpg_value"
                fullWidth
                validate={[required()]}
                className={classes.input}
              />
            </Grid>
            <Grid item xs={6}>
              <NumberInput fullWidth source="rpg_rrp" className={classes.input} />
            </Grid>
            <Grid item xs={3}>
              <BooleanInput
                source="rpg_inquiry"
                defaultValue={false}
                validate={[required()]}
                className={classes.input}
              />
            </Grid>
            <Grid item xs={3}>
              <BooleanInput source="rpg_status" defaultValue={true} className={classes.input} />
            </Grid>
            <Grid item xs={6}>
              {/* <BooleanInput
                fullWidth
                label="Available"
                defaultValue={true}
                source="available"
                validate={[required()]}
              /> */}
            </Grid>
          </Grid>
        </div>
      </SimpleForm>
    </Create>
  )
}
